import React, { useEffect } from 'react'

import { FormApi } from 'final-form'
import { first, forEach, join, split } from 'lodash'
import { Col, Row } from 'react-bootstrap'

import Button from '../../Button'
import ButtonGroup from '../../ButtonGroup'
import CronConfigurator from '../../CronConfigurator'
import Field, { required } from '../../Field'
import Input from '../../Input'
import TagInput from '../../TagInput'

type TForm = {
  form?: FormApi
  getFormApi?: (form: FormApi) => void
  setDialog?: (val: boolean) => void
  initialValues?: {
    [key: string]: any
  }
}
const Form = (props: TForm): React.ReactElement => {
  const { form, getFormApi, setDialog } = props

  useEffect(() => {
    if (form && getFormApi) {
      getFormApi(form)
      const values = props.initialValues

      form.batch(() => {
        forEach(values, (value, key) => form.change(key, value))
      })
    }
  }, [])

  return (
    <>
      <Row>
        <Col md="6">
          <Field
            name="name"
            label={i18n.t('name', 'Name')}
            required
            validate={required}
          >
            <Input />
          </Field>
        </Col>
      </Row>
      <CronConfigurator
        name="cronConfig"
        form={form}
      />
      <Row className="mt-2">
        <Col>
          <TagInput
            name="recipientMails"
            validate={
              (t: string) =>
                t
                  ? false
                  : (i18n.t('required_tt', 'Pflichtfeld') as unknown as boolean) // validate gets passes as validatorFunc to fieldProps
            }
            validationRegex={
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            }
            required
            label={i18n.t(
              'recipientMails_label',
              'Empfänger Email-Adressen für Labelversand',
            )}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col
          md={12}
          className="d-flex justify-content-end"
        >
          <ButtonGroup>
            <Button
              variant="danger"
              onClick={() => setDialog && setDialog(false)}
            >
              <b>{i18n.t('btn_cancel', 'Abbrechen')}</b>
            </Button>
            <Button
              variant="success"
              onClick={form && form.submit}
            >
              <b>{i18n.t('btn_save', 'Speichern')}</b>
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
    </>
  )
}

export default Form

export const stringifyValues = (values: any): any => {
  if (!values) return {}
  const cronPatterns = makeCronPatterns(
    values.cronPattern,
    values.cronConfig?.cronTimes,
  )
  return {
    ...values,
    cronPatterns,
    cronPattern: first(cronPatterns),
  }
}

export const parseValues = (values: { [key: string]: any }): any => {
  if (!values) return {}

  return {
    ...values,
  }
}

function makeCronPatterns(pattern: string, times: any[]): string[] {
  if (!times) return [pattern]
  return times.map((time) => {
    const patternParts = split(pattern, ' ')
    const splitValues = time.split(':')
    patternParts[0] = splitValues[1]
    patternParts[1] = splitValues[0]
    return join(patternParts, ' ')
  })
}
